var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("card-collapsable", {
    attrs: {
      headerClass: _vm.headerClass,
      dialogClass: "selvaggia",
      dialogProp: _vm.dialog,
    },
    scopedSlots: _vm._u([
      {
        key: "visible",
        fn: function () {
          return [
            _c("progress-countdown", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.asta_settings.timeout_s && _vm.calciatoreInAsta,
                  expression: "asta_settings.timeout_s && calciatoreInAsta",
                },
              ],
              ref: "timer_selvaggia",
              attrs: { time: _vm.asta_settings.timeout_s, name: "selvaggia" },
              on: {
                timeStep: _vm.setSelvaggiaTimeLeft,
                timeover: _vm.timeoverSelvaggia,
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "title",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.selvaggiaCannotJoinReason && !_vm.sonoVincitore
                    ? _vm.selvaggiaCannotJoinReason
                    : _vm.hoPassato
                    ? _vm.selvaggiaPassoText
                    : _vm.sonoVincitore
                    ? "Migliore offerta"
                    : "Fai offerta"
                ) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.calciatoreInAsta
              ? _c("calciatore-battuto", {
                  attrs: { id: _vm.calciatoreInAsta, xLarge: "" },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "text-center" }, [
              _c(
                "div",
                { staticClass: "d-flex justify-center" },
                [
                  _c("squadra-offerta", {
                    class: { sonoVincitore: _vm.sonoVincitore },
                    attrs: {
                      offerta: _vm.migliore_offerta.offerta,
                      uid: _vm.migliore_offerta.vincitore,
                      ifNoOfferta: "Nessuna offerta",
                      variant: "horizontal",
                      creditiGlow: "",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.timeover &&
              _vm.running &&
              _vm.calciatoreInAsta !== null &&
              _vm.sonoVincitore &&
              _vm.creditiInsufficienti
                ? _c(
                    "div",
                    { staticClass: "pa-2" },
                    [
                      _c("v-chip", { staticClass: "white primary--text" }, [
                        _vm._v("Non puoi alzare ulteriormente l'offerta"),
                      ]),
                    ],
                    1
                  )
                : !_vm.timeover &&
                  _vm.running &&
                  _vm.calciatoreInAsta !== null &&
                  !_vm.hoPassato
                ? _c("div", { staticClass: "pa-4" }, [
                    _vm.migliore_offerta.offerta
                      ? _c(
                          "div",
                          { staticClass: "d-flex justify-center" },
                          [
                            !_vm.offertaToConfirm
                              ? _vm._l(
                                  _vm.rilanciRelativi,
                                  function (incremento) {
                                    return _c(
                                      "v-btn",
                                      {
                                        key: incremento,
                                        staticClass: "ma-1",
                                        attrs: {
                                          rounded: "",
                                          color: "primary",
                                          disabled:
                                            !_vm.canRilanciareDi(incremento),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.preparaRilancio(
                                              incremento
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              +" +
                                            _vm._s(incremento) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  }
                                )
                              : _vm.offertaToConfirm
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex flex-column align-center",
                                  },
                                  [
                                    _vm.offertaInsufficiente
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-center error--text",
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "error--text",
                                                attrs: { small: "", left: "" },
                                              },
                                              [_vm._v("error")]
                                            ),
                                            _vm._v(
                                              "\n              Offerta ora insufficiente. Vuoi offrire\n              " +
                                                _vm._s(_vm.offertaToConfirm) +
                                                " ?\n            "
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "ma-1 pr-1",
                                        attrs: {
                                          rounded: "",
                                          color: "primary",
                                        },
                                        on: { click: _vm.confirmOfferta },
                                      },
                                      [
                                        _vm._v("Confermo\n              "),
                                        _c("crediti", {
                                          staticClass: "ml-2",
                                          attrs: {
                                            crediti: _vm.offertaToConfirm,
                                            variant: "dark",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "v-menu",
                                          {
                                            attrs: { "offset-y": "", left: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function (ref) {
                                                    var on = ref.on
                                                    var attrs = ref.attrs
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticClass:
                                                                "ml-1 white--text",
                                                              attrs: {
                                                                icon: "",
                                                                "x-small": "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                  },
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                small: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "expand_more"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              303347142
                                            ),
                                          },
                                          [
                                            _vm._v(" "),
                                            _c(
                                              "v-list",
                                              {
                                                staticClass:
                                                  "selvaggia-confirm-menu",
                                                attrs: { dense: "" },
                                              },
                                              [
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    on: {
                                                      click:
                                                        _vm.annullaOffertaToConfirm,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item-icon",
                                                      { staticClass: "mr-2" },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              small: "",
                                                              color: "navy",
                                                            },
                                                          },
                                                          [_vm._v("close")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-list-item-title",
                                                      {
                                                        staticClass:
                                                          "navy--text text--darken-2 font-weight-bold pr-4",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      Annulla offerta\n                    "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-center" },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "ma-1",
                            attrs: {
                              color: "primary",
                              id: "numpad-btn",
                              rounded: "",
                              depressed: "",
                            },
                            on: { click: _vm.showNumpad },
                          },
                          [_vm._v("\n            Offerta\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass: "ma-1",
                            attrs: {
                              color: "primary",
                              outlined: "",
                              rounded: "",
                              disabled: _vm.vincitore === _vm.user_uid,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.setPasso(true)
                              },
                            },
                          },
                          [_vm._v("\n            Passo\n          ")]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm.hoPassato
                ? _c(
                    "div",
                    { staticClass: "pa-2" },
                    [
                      _c("v-chip", { staticClass: "orange white--text" }, [
                        _vm._v(_vm._s(_vm.selvaggiaPassoText)),
                      ]),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "pa-2" },
                    [
                      _c("v-chip", { staticClass: "orange white--text" }, [
                        _vm._v("In attesa degli altri partecipanti..."),
                      ]),
                    ],
                    1
                  ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _vm.my_squadra
              ? _c(
                  "div",
                  { staticClass: "pa-4" },
                  [
                    _c("squadra-info-panel", {
                      attrs: { id_squadra: _vm.user_uid },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.my_squadra
              ? _c(
                  "div",
                  { staticClass: "px-4 pb-4" },
                  [
                    _c(
                      "v-list",
                      {
                        staticClass:
                          "recycle-scroller navy darken-2 pb-2 rounded",
                        class: { "nice-scroll": !_vm.is_mobile },
                      },
                      [
                        _c("div", { staticClass: "text-center py-2 " }, [
                          _vm._v("Pianificazione ruolo"),
                        ]),
                        _vm._v(" "),
                        _c("asta-consiglio"),
                        _vm._v(" "),
                        _vm._l(
                          _vm.myPlan[_vm.ruolo_abc],
                          function (slotData, slot, i) {
                            return _c("asta-slot", {
                              key: _vm.ruolo_abc + "_" + slot,
                              attrs: {
                                ruolo_abc: _vm.ruolo_abc,
                                iSlot: slot,
                                i: i,
                              },
                            })
                          }
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }